var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnOnboardingModelOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_onboarding_model_off"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1118 48.8886C17.1118 48.8886 14.2229 48.8886 14.2229 45.9997C14.2229 43.1108 17.1118 34.4441 31.5562 34.4441C46.0007 34.4441 48.8896 43.1108 48.8896 45.9997C48.8896 48.8886 46.0007 48.8886 46.0007 48.8886H17.1118ZM31.5562 31.5553C33.8548 31.5553 36.0592 30.6422 37.6845 29.0168C39.3098 27.3915 40.2229 25.1871 40.2229 22.8886C40.2229 20.59 39.3098 18.3856 37.6845 16.7603C36.0592 15.135 33.8548 14.2219 31.5562 14.2219C29.2577 14.2219 27.0533 15.135 25.428 16.7603C23.8027 18.3856 22.8896 20.59 22.8896 22.8886C22.8896 25.1871 23.8027 27.3915 25.428 29.0168C27.0533 30.6422 29.2577 31.5553 31.5562 31.5553Z",
    fill: "#999999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnOnboardingModelOff);
export default __webpack_public_path__ + "static/media/icn_onboarding_model_off.4e7fc3339f19ceb398cab2d32c5e5953.svg";
export { ForwardRef as ReactComponent };